import React from 'react';

import QuestionHOC from './QuestionHOC';

function PageBreak({ item, index }) {
  return <QuestionHOC item={item} index={index}>
    <p className="document-builder__page-break mt-1 mb-1 text-center text-muted">Page Break</p>
  </QuestionHOC>
}


export default PageBreak;